<template>
  <div>
    <v-row>
      <v-col md="3">
        <v-text-field hide-details="auto" type="date" solo flat background-color="grey lighten-4"
          v-model="searchParams.due_date_start" label="Vencimento Inicial" @change="select(1)" />
      </v-col>
      <v-col md="3">
        <v-text-field hide-details="auto" type="date" solo flat background-color="grey lighten-4"
          v-model="searchParams.due_date_end" label="Vencimento Final" @change="select(1)" />
      </v-col>
      <v-col md="6">
        <AccountPlanSelect v-model="searchParams.account_plan_id" :item-value="(val) => val.id" :dense="false" solo flat
          background-color="grey lighten-4" multiple clearable @change="select(1)" />
      </v-col>
    </v-row>
    <v-row>
      <v-col md="6">
        <company-select chips multiple v-model="searchParams.company_id" :item-value="(val) => val.id"
          :itemText="(val) => val.short_name" solo flat background-color="grey lighten-4" :dense="false"
          @change="select(1)" />
      </v-col>
      <v-col md="6">
        <v-chip-group v-model="searchParams.status" multiple mandatory @change="select(1)">
          <v-chip filter outlined value="foreseen"> Previsão </v-chip>
          <v-chip filter outlined value="to_pay"> A Pagar </v-chip>
          <v-chip filter outlined value="scheduled"> Agendado </v-chip>
          <v-chip filter outlined value="paid"> Pago </v-chip>
          <v-chip filter outlined value="canceled"> Cancelado </v-chip>
        </v-chip-group>
      </v-col>
    </v-row>
    <v-row>
      <v-col md="4">
        <v-card color="primary" elevation="0" dark>
          <v-card-text class="d-flex align-center justify-space-between">
            <div>
              Total
              <br />
              <b class="text-h5">{{
                $format.decimal(billPayablesSum.total_value || 0)
                }}</b>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col md="4">
        <v-card color="grey lighten-4" elevation="0">
          <v-card-text class="d-flex align-center justify-space-between">
            <div>
              Total a Pagar
              <br />
              <b class="text-h5">{{
                $format.decimal(billPayablesSum.total_to_pay || 0)
                }}</b>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col md="4">
        <v-card color="grey lighten-4" elevation="0">
          <v-card-text class="d-flex align-center justify-space-between">
            <div>
              Total Pago
              <br />
              <b class="text-h5">{{
                $format.decimal(billPayablesSum.total_paid || 0)
                }}</b>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-card flat color="grey lighten-4">
          <v-card-title>
            <span>Contas a pagar por mês</span>
          </v-card-title>
          <v-card-text>
            <div>
              <apexchart width="100%" height="300px" type="bar" :options="chartOptions" :series="chartSeries">
              </apexchart>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-card flat color="grey lighten-4">
          <v-card-title>
            <span class="text-h6 font-weight-medium">Contas a Pagar por Fornecedor</span>
          </v-card-title>
          <v-card-text>
            <v-data-table class="grey lighten-4" :headers="headers" :items="supliers.data"
              hide-default-footer></v-data-table>
            <app-pagination @click="select($event)" :data="supliers" />
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>


<script>
import AccountPlanSelect from "@/components/account-plan/ui/AccountPlanSelect.vue";
import CompanySelect from "@/components/company/ui/CompanySelect.vue";

import { format, startOfMonth, parse } from "date-fns";
import { ptBR } from 'date-fns/locale';

export default {
  components: {
    AccountPlanSelect,
    CompanySelect
  },

  data() {
    return {
      options: {},

      headers: [
        { text: 'Fornecedor', value: 'supplier' },
        { text: 'Valor a Pagar', value: 'total' },
      ],
      supliers: [],

      chartSeries: [],

      searchParams: {
        company_id: [],
        account_plan_id: [],
        due_date_start: format(startOfMonth(new Date()), 'yyyy-MM-dd'),
        due_date_end: format(new Date(), 'yyyy-MM-dd'),
        status: ["to_pay", "paid"],
      },

      billPayablesSum: {
        total_value: 0,
        total_paid: 0,
        total_to_pay: 0,
        monthly_summary: []
      },

      isLoading: false,

      chartOptions: {
        chart: {
          id: 'vuechart-example',
          type: 'bar',
          height: 400,
          toolbar: { show: false },
          zoom: {
            enabled: false
          },

        },
        stroke: {
          width: 1,
          colors: ['#fff']
        },

        plotOptions: {
          bar: {
            horizontal: false,
            borderRadius: 10,
            borderRadiusApplication: 'end',
            borderRadiusWhenStacked: 'last',
            dataLabels: {

              total: {
                enabled: false,
                style: {
                  fontSize: '12px',
                  fontWeight: 500
                }
              }
            },
            columnWidth: '70%',
          },
        },


        dataLabels: {
          enabled: false,
        },
        xaxis: {
          categories: [],
          labels: {
            position: 'top',
            style: {
              align: 'right',
              colors: '#9aa0ac',
              fontSize: '12px',
            }
          }
        },
        yaxis: {
          labels: {
            formatter: function (val) {
              return `R$ ${val.toFixed(2)}`;
            }
          }
        },
        fill: {
          opacity: 1
        },
        tooltip: {
          label: false,

          y: {
            formatter: function (val) {
              return `R$ ${val.toFixed(2)}`;
            },
          },
        },
        // colors: ['#adadad', '#949494', '#474747' ,'#3c3b3b','#262626', ],
        colors: ['#1E90FF', '#32CD32', '#ffa500' ,'#ffff00','#7dd3fc','#FF4C4C', ],
      },
    };
  },

  mounted() {
    this.select(1);
  },

  computed: {},

  methods: {
    async select(page = 1) {
      this.searchParams.page = page;
      this.options.page = page;
      this.isLoading = true;

      try {
        const [response, response2] = await Promise.all([
          this.$http.index("bill-payable/bill-payable-dashboard", this.searchParams),
          this.$http.index("bill-payable/bill-payable-suplier", this.searchParams),
        ]);

        this.billPayablesSum = response;

        const categories = [];
        const total = [];
        const paid = [];
        const toPay = [];
        const foreseen = [];
        const scheduled = [];
        const canceled = [];

        response.monthly_summary.forEach((item) => {
          const parsedDate = parse(item.due_month, 'yyyy-MM', new Date());
          const formattedDate = format(parsedDate, 'MMM/yyyy', { locale: ptBR });

          categories.push(formattedDate);
          total.push(Number(item.total_value) || 0);
          paid.push(Number(item.total_paid) || 0);
          toPay.push(Number(item.total_to_pay) || 0);
          foreseen.push(Number(item.total_foreseen) || 0);
          scheduled.push(Number(item.total_scheduled) || 0);
          canceled.push(Number(item.total_canceled) || 0);
        });


        this.chartOptions = {
          ...this.chartOptions,
          xaxis: {
            ...this.chartOptions.xaxis,
            categories: categories
          }
        };

        this.chartSeries = [
          { name: 'Total', data: total },
          { name: 'Pago', data: paid },
          { name: 'A Pagar', data: toPay },
          { name: 'Previsão', data: foreseen },
          { name: 'Agendado', data: scheduled },
          { name: 'Cancelado', data: canceled },
        ];

        this.supliers = response2;

      } catch (error) {
        console.error('Erro ao buscar os dados:', error);
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>